export const Logo = ({ light = false }) => (
  <span className="flex items-center" data-testid="brand-logo">
    {light ? (
      <span className="inline-flex items-center rounded-md bg-white px-3.5 py-2.5 shadow-[0_4px_16px_rgb(0,0,0,0.15)]">
        <img
          src="/logo.webp"
          alt="Ford & Associates — Accounting & Taxation"
          className="h-8 w-auto"
          loading="lazy"
        />
      </span>
    ) : (
      <img
        src="/logo.webp"
        alt="Ford & Associates — Accounting & Taxation"
        className="h-9 w-auto sm:h-11"
      />
    )}
  </span>
);

export default Logo;
